import { createSelector } from 'reselect';
import { SEASON_AGNOSTIC } from '../types';
import { AppState } from '../store/types/Store';
import { getViewIndex } from './commonSelectors';
import { getCurrentSeason } from './seasonSelectors';

const getScouting = (state: AppState) => state.scouting;

export const getSelectedActivity = createSelector([
  getScouting, getViewIndex
], (scouting, index) => scouting.selectedActivity[index]);

export const getActivities = (state: AppState, props: { index: number }) => {
  const season = getCurrentSeason(state, props).split(':')[0];
  const seasonActivities = state.scouting.activities[season] || [];
  const agnosticActivities = state.scouting.activities[SEASON_AGNOSTIC] || [];

  return seasonActivities.concat(agnosticActivities);
};

export const getActivitiesWithoutFieldNotes = createSelector(
  [getActivities],
  (activities) => activities.filter((activity) => activity.location)
);

export const getActivityLoading = createSelector(
  [getScouting],
  scouting => scouting.isLoadingActivity || scouting.isLoadingUpdatedActivity
);

export const getCategories = createSelector(
  [getScouting],
  (scouting) => scouting.categories
);

export const getCategoriesStatus = createSelector(
  [getScouting],
  scouting => scouting.categoriesStatus
);
